import IGrupoEtnico from '../../interfaces/IGrupoEtnico';
import IGrupoEtnicoParaSelect from '../../interfaces/IGrupoEtnicoParaSelect';

export const mapearGrupoEtnicoParaSelect = (gruposEtnicos: IGrupoEtnico[]): IGrupoEtnicoParaSelect[] =>
  gruposEtnicos.map(({ id, nome }) => ({
    value: id,
    label: nome
  }));